import { Component, ElementRef, HostListener, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';

@Component({
  selector: 'app-sustainability-achieved',
  templateUrl: './sustainability-achieved.component.html',
  styleUrls: ['./sustainability-achieved.component.css'],
  animations: [
    trigger('switchTab', [
      state('fadeIn', style({
        opacity: 1,
        transform: 'translateY(0%)'
      })),

      transition('void => *', [style({opacity: 0, transform: 'translateY(5%)'}),animate('0.5s ease')]),
    ]),

    trigger('envOnHover', [
      state('before', style({
        background: 'rgb(206, 253, 197)',
        transform: 'translateX(0)',
        width: '110%'
      })),
      state('hover',style({
        background: 'rgb(125, 247, 101)',
        transform: 'translateX(-10%)',
        width: '110%'
      })),

      transition('before <=> hover', animate('0.5s ease'))
    ]),

    trigger('socOnHover', [
      state('before', style({
        background: 'rgb(255, 212, 202)',
        width: '110%',
        transform: 'translateX(0)'
      })),
      state('hover',style({
        background: 'rgb(255, 164, 141)',
        width: '110%',
        transform: 'translateX(-10%)'
      })),

      transition('before <=> hover', animate('0.5s ease'))
    ]),

    trigger('ecoOnHover', [
      state('before', style({
        background: 'rgb(255, 240, 200)',
        width: '110%',
        transform: 'translateX(0)'
      })),
      state('hover',style({
        background: 'rgb(245, 202, 85)',
        width: '110%',
        transform: 'translateX(-10%)'
      })),

      transition('before <=> hover', animate('0.5s ease'))
    ])
  ]
})
export class SustainabilityAchievedComponent implements OnInit {

  selectedEnv = "air";
  selectedSoc = "injury";
  selectedEco = "supplier";
  envHover = [false,true,false,false];
  socHover = [false, true];
  ecoHover = [true, false];
  icons = [{image: 'assets/images/water-icon.png'}, {image: 'assets/images/water-icon2.png'}, 
  {image: 'assets/images/air-icon2.png'}, {image:'assets/images/air-icon3.png'}, 
  {image: 'assets/images/waste-icon2.png'}, {image:'assets/images/waste-icon3.png'},
  {image: 'assets/images/energy-icon.png'}, {image:'assets/images/energy-icon2.png'},
  {image: 'assets/images/employee-icon2.png'}, {image: 'assets/images/employee-icon3.png'},
  {image: 'assets/images/health-icon2.png'}, {image: 'assets/images/health-icon3.png'},
  {image: 'assets/images/supplier-icon.png'}, {image: 'assets/images/supplier-icon2.png'},
  {image: 'assets/images/customer-icon.png'}, {image: 'assets/images/customer-icon2.png'}];
  waterIcon = this.icons[1].image;
  airIcon = this.icons[3].image;
  wasteIcon = this.icons[4].image;
  energyIcon = this.icons[6].image;
  employeeIcon = this.icons[9].image;
  healthIcon = this.icons[11].image;
  supplierIcon = this.icons[13].image;
  customerIcon = this.icons[14].image;

  @Input() tabOnView: boolean;

  constructor() { 
    this.tabOnView = Boolean();
  }

  ngOnInit(): void {
  }

  selectEnv(target: string) {
    this.selectedEnv = target;

    if(target == "water") {
      this.envHover.fill(false);
      this.envHover[0] = true;
    }
    else if (target == "air") {
      this.envHover.fill(false);
      this.envHover[1] = true;
    }
    else if (target == "waste") {
      this.envHover.fill(false);
      this.envHover[2] = true;
    }
    else if (target == "energy") {
      this.envHover.fill(false);
      this.envHover[3] = true;
    }


    // To change the icon image while mouse enter or mouse out
    if (this.envHover[0] == false)
    {
      this.waterIcon = this.icons[0].image;
    }
    else {
      this.waterIcon = this.icons[1].image;
    }

    if (this.envHover[1] == false) {
      this.airIcon = this.icons[2].image;
    }
    else {
      this.airIcon = this.icons[3].image;
    }

    if (this.envHover[2] == false) {
      this.wasteIcon = this.icons[4].image;
    }
    else {
      this.wasteIcon = this.icons[5].image;
    }

    if (this.envHover[3] == false) {
      this.energyIcon = this.icons[6].image;
    }
    else {
      this.energyIcon = this.icons[7].image;
    }
  }

  selectSoc(target: string) {
    this.selectedSoc = target;

    if(target == "employee") {
      this.socHover.fill(false);
      this.socHover[0] = true;
    }
    else if (target == "injury") {
      this.socHover.fill(false);
      this.socHover[1] = true;
    }

    // To change the icon image while mouse enter or mouse out
    if (this.socHover[0] == false) {
      this.employeeIcon = this.icons[8].image;
    }
    else {
      this.employeeIcon = this.icons[9].image;
    }
    
    if (this.socHover[1] == false) {
      this.healthIcon = this.icons[10].image;
    }
    else {
      this.healthIcon = this.icons[11].image;
    }
  }

  selectEco(target: string) {
    this.selectedEco = target;
  
    if(target == "supplier") {
      this.ecoHover.fill(false);
      this.ecoHover[0] = true;
    }
    else if (target == "customer") {
      this.ecoHover.fill(false);
      this.ecoHover[1] = true;
    }

    // To change the icon image while mouse enter or mouse out
    if (this.ecoHover[0] == false) {
      this.supplierIcon = this.icons[12].image;
    }
    else {
      this.supplierIcon = this.icons[13].image;
    }

    if (this.ecoHover[1] == false) {
      this.customerIcon = this.icons[14].image;
    }
    else {
      this.customerIcon = this.icons[15].image;
    }
  }
}
